import { FormGroup } from '@angular/forms';

// custom validator to check password strength
export function PasswordStrength(controlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    var pattern = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])");

    // return null if controls haven't initialised yet
    if (!control) {
      return null;
    }

    // return null if another validator has already found an error on the matchingControl
    if (control.errors && !control.errors.passwordStrength) {
      return null;
    }


    // set error on matchingControl if validation fails
    if (control.value!="" && !pattern.test(control.value)) {
      control.setErrors({ passwordStrength: true });
    } else {
      control.setErrors(null);
    }
  }
}

